import React from "react";

import {WizTableForm} from "@/containers/common";
import moment from "moment/moment";

let componentName = 'notes';

const columns = (self) => {

  return [
    {
      name: "id",
      formItem: {
        type: "hidden"
      }
    },
    {
      title: "标题",
      name: 'title',
      searchItem: {},
      tableItem: {},
    },
    {
      title: "作者",
      name: 'personIds',
      dataIndex: 'personIds',
      searchItem: {
        ...WizTableForm.Config.user(self, {apiParams: { state: 1 }}),
        diy: WizTableForm
      },
    },
    {
      title: "作者",
      name: 'fullName',
      dataIndex: 'fullName',
      tableItem: {},
    },
    {
      title: "账号",
      name: 'userName',
      dataIndex: 'userName',
      tableItem: {},
    },
    {
      title: "关联类型",
      name: 'bizType',
      dataIndex: 'bizType',
      dict: [
        {code: 20, codeName: '学习资料'},
      ],
      searchItem: {
        type: 'select'
      },
      tableItem: {},
    },
    // {
    //   title: "关联内容",
    //   name: 'bizId',
    //   dataIndex: 'bizId',
    //   searchItem: {
    //     type: 'diy',
    //     diy: WizTableForm,
    //     links: {'bizType': '关联内容'},
    //     ...WizTableForm.Config.program(this, {}),
    //     changePopsFunction: (linksValues) => {
    //       const {bizType} = linksValues
    //       let other = {
    //         selectType: 'radio'
    //       }
    //       let config;
    //       if (bizType === 0) {
    //         config = WizTableForm.Config.program(this, {})
    //       } else if (bizType === 20) {
    //         config = WizTableForm.Config.content(this, {apiParams: {hiddenType: 1}})
    //       }
    //       if (config == null) {
    //         other.disabled = true;
    //       }
    //       let tableFormProps = {
    //         ...config,
    //         ...other
    //       }
    //       return tableFormProps
    //     },
    //   }
    // },
    {
      title: "关联内容",
      name: "bizName",
      dataIndex: "bizName",
      searchItem: {},
      tableItem: {
        render: (text, record) => {
          switch (record?.bizType) {
            case 20:
              return <a onClick={() => self.jumpPage('push', '/content/learningMaterialsManage/view', {id: record?.bizId})}>{text}</a>
            default:
              return text;
          }
        }
      },
    },
    {
      title: "是否公开",
      name: "isPublic",
      dataIndex: "isPublic",
      dict: [
        {code: 0, codeName: '否'},
        {code: 1, codeName: '是'},
      ],
      searchItem: {
        type: 'select'
      },
      tableItem: {},
    },
    {
      title: "更新时间",
      name: "lastUpdateTime",
      dataIndex: "lastUpdateTime",
      searchItem: {
        type: 'date~',
        format: 'YYYY-MM-DD',
      },
      tableItem: {},
    },
  ]
}

const templateConfig = (self) => {
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns(self),
        searchBarProps: {
          collapse: false,
          cols: {
            xs: 24,
            md: 12,
            xl: 8
          },
          dataFormat: (params) => {
            let value = Object.assign({}, params)
            if (value.lastUpdateTime && value.lastUpdateTime.length === 2) {
              value.startTime = moment(value.lastUpdateTime[0]).format('YYYY-MM-DD HH:mm:ss')
              value.endTime = moment(value.lastUpdateTime[1]).format('YYYY-MM-DD HH:mm:ss')
            }
            return value
          },
          buttonSort: ['export'],
          buttons: [
            {
              key: 'export',
              custom: true,
              params: { icon: 'export', children: '导出', type: 'export' },
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return { ...filters }
                }
              }
            },
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: 'id',
          isScroll: true,
          bordered: false,
          paging: false,
          loading: false,
        },
        rowOperateSort: ['recordManagement'],
        rowOperateView: [
          {
            key: "recordManagement",
            custom: true,
            params: { children: "记录管理" },
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/notes/notesManage/record",
              },
            },
          },
        ],
        commonOperate: {},
      }
    }
  };
}

const apis = () => {
  return {
    list: {
      path: `${componentName}/list`,
      payload: {
        key: `${componentName}@list`,
        apiParams: {}
      }
    },
    export: {
      path: `${componentName}/export`,
      payload: {
        key: `${componentName}@export`,
        apiParams: {}
      }
    }
  }
}

let reduxTemplateConfig = (args) => {
  return {
    apis: apis(),
    componentName,
    initApiKeys: ['list'],
    keepInitApiParams:true,
    needLoading: true,
    ...args
  }
};

export {reduxTemplateConfig, templateConfig};
